import { render, staticRenderFns } from "./AIpage.vue?vue&type=template&id=2e5aa231&scoped=true"
import script from "./AIpage.vue?vue&type=script&lang=js"
export * from "./AIpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5aa231",
  null
  
)

export default component.exports